import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

import { PromptModel as PromptModelResponse } from '../../types/sylvanus/model';

interface Request {
  modelId: Uuid;
}

type Response = PromptModelResponse;

export const getPromptModelPublish = async ({
  modelId,
}: Request): Promise<Response> => {
  const response = await sylvanus.get(`/model/${modelId}/publish`);

  return response;
};
